/**
 * A class representing a Clickable Element.
 *
 * @class
 */
class ClickableElement {

	/**
	 * Initializes the object with the provided clickable elements.
	 *
	 * @param {NodeList|HTMLElement[]} elements - A NodeList or an array of HTML elements that will be clickable.
	 * @class
	 */
	constructor( elements ) {

		this.clickableElements = elements instanceof NodeList ? Array.from( elements ) : elements;

		if ( this.clickableElements.length ) {

			this.event();

		}

	}

	/**
	 * Binds click event handler to clickable elements.
	 */
	event() {

		this.clickableElements.forEach( ( clickableElement ) => {

			clickableElement.addEventListener( 'click', () => this.handleClick( clickableElement ) );

		} );

	}

	/**
	 * Handles the click event on a clickable element.
	 * If the element contains a link, it redirects the user to the link's URL.
	 *
	 * @param {HTMLElement} clickableElement - The clickable element to handle the click event on.
	 * @return {void}
	 */
	handleClick( clickableElement ) {

		const linkElement = clickableElement.querySelector( 'a' );
		if ( linkElement ) {

			linkElement.dispatchEvent( new Event( 'click', { } ) );

		}

	}

}

export default ClickableElement;
